<template>
    <div class="package-steps">
        <template v-for="(label, index) in labels">
            <div class="step"
                 :key="'step-' + index"
                 :class="{'active': index + 1 === step, 'done': index + 1 < step}"
                 @click="go(index + 1)">
                <div class="circle">
                    <i class="fas fa-check" v-if="index + 1 < step"></i>
                    <span v-else>{{ index + 1 }}</span>
                </div>
                <div class="label">{{ label }}</div>
            </div>
            <div class="line" :key="'line-' + index" v-if="index < labels.length - 1"></div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "PackageSteps",
        props: {
            step: {type: Number, required: true}
        },
        data: function() {
            return {
                labels: ['Your Needs', 'Your Focus', 'Courses', 'Payment', 'Review']
            };
        },
        methods: {
            // Completed steps are re-openable; future steps only via Continue
            go(step) {
                if (step < this.step) {
                    this.$emit('go', step);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .package-steps {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 1.5rem 0 1.6rem;
        max-width: 860px;

        .step {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;

            .circle {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.8rem;
                font-weight: 900;
                background: rgba(255, 255, 255, 0.18);
                color: #c7d6e6;
            }

            .label {
                font-size: 0.8rem;
                font-weight: bold;
                color: #b9cbde;

                @media (max-width: 768px) {
                    display: none;
                }
            }

            &.active {
                .circle {
                    background: #ffffff;
                    color: #2e5f8f;
                }

                .label {
                    color: #ffffff;

                    @media (max-width: 768px) {
                        display: block;
                    }
                }
            }

            &.done {
                cursor: pointer;

                .circle {
                    background: #5c86b3;
                    color: #ffffff;
                }
            }
        }

        .line {
            flex: 1;
            height: 2px;
            background: rgba(255, 255, 255, 0.28);
        }
    }
</style>
